export const SIGNATURE_BASE_PATH = 'signature';
